var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Media.less');

var MediaVideoList = require('front/components/MediaVideoList/MediaVideoList');

module.exports = Section.extend({

    el: '.Media',

    events: {
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'MediaVideoList': {selector: '.MediaVideoList', viewConstructor: MediaVideoList}
    },

    initialize: function (options) {
        this.options = options || {};

        if (app.settings.isPhone) {
            this.$('.Media-featured').owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                mouseDrag: false,
                smartSpeed: 500,
                loop: true
            });
        }

        Section.prototype.initialize.call(this, options);
    },

    activate: function () {
        _.bindAll(this, 'resizeReleaseText');

        this.$('.Media-featured-itemLead').dotdotdot({
            watch: true
        });

        window.app.vent.on('fonts-loaded', this.resizeReleaseText);

        return Section.prototype.activate.call(this);
    },

    deactivate: function (params) {
        window.app.vent.off('fonts-loaded', this.resizeReleaseText);

        return Section.prototype.deactivate.call(this, params);
    },

    render: function () {
        var result = Section.prototype.render.call(this);

        return result;
    },

    resizeReleaseText: function () {
        this.$('.Media-featured-itemLead').trigger('update.dot');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Media/Media.js
// module id = 276
// module chunks = 0